import React from 'react'

function Main({ children }) {
  return (
    <main className="flex-1">
      <div className="">
        {children}
      </div>
    </main>
  )
}

export default Main